import React from "react";
import { connect } from "react-redux";

import ReactHookFormTitleWithRadio from "components/reactHookFormComponents/ReactHookFormTitleWithRadio";
import { useFormContext } from "react-hook-form";
import ReactHookFormTextWithTitle from "components/reactHookFormComponents/ReactHookFormTextWithTitle";

export const REWARD_LOGIC_TYPE = {
  baseOnTransactionValue: "TRANSACTION_VALUE",
  baseOnItemQuantity: "ITEM_QUANTITY",
}

export const DISPLAY_REWARD_LOGIC_TYPE = {
  [REWARD_LOGIC_TYPE.baseOnTransactionValue]: "Based on the spending(transaction value)",
  [REWARD_LOGIC_TYPE.baseOnItemQuantity]: "Based on the items quantity",
}
const RewardLogicSelector = ({
}) => {
  const { watch } = useFormContext();
  const watchLineItemRequirement = watch("lineItemRequirement");

  return <>
    {watchLineItemRequirement ?
      <>
        <ReactHookFormTitleWithRadio
          title="Reward logic"
          valueFieldName="rewardLogicType"
          defaultValue={REWARD_LOGIC_TYPE.baseOnTransactionValue}
          options={[
            { label: DISPLAY_REWARD_LOGIC_TYPE[REWARD_LOGIC_TYPE.baseOnTransactionValue], value: REWARD_LOGIC_TYPE.baseOnTransactionValue },
            { label: DISPLAY_REWARD_LOGIC_TYPE[REWARD_LOGIC_TYPE.baseOnItemQuantity], value: REWARD_LOGIC_TYPE.baseOnItemQuantity },
          ]}
        />
      </>
      : <ReactHookFormTextWithTitle
        title="Reward logic"
        customValue={DISPLAY_REWARD_LOGIC_TYPE[REWARD_LOGIC_TYPE.baseOnTransactionValue]}
      />
    }
  </>
}

const mapPropsToState = (state) => ({
});

export default connect(mapPropsToState)(RewardLogicSelector);